/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
export type AdviceCardType =
  (typeof AdviceCardType)[keyof typeof AdviceCardType];

export const AdviceCardType = {
  exploration: 'exploration',
  action: 'action',
  resource: 'resource',
} as const;

/**
 * Advice cards to be sent by client
 */
export interface AdviceCard {
  id: string;
  image_url: string;
  theme: string;
  type: AdviceCardType;
  value: string;
}

/**
 * An Advice Card message to be sent by user
 */
export interface AdviceCardMessage {
  type?: 'advice_card';
  subtype?: string | null;
  type_discriminator?: 'advice_card';
  value: string | null;
  advice_card_id: string;
}

/**
 * A text based message to be sent by user
 */
export interface ChatTextMessageInput {
  type?: 'text';
  subtype?: string | null;
  type_discriminator?: 'text';
  value: string | null;
}

/**
 * A text based message to be sent by user
 */
export interface ChatTextMessageOutput {
  type?: 'text';
  subtype?: string | null;
  value: string | null;
}

/**
 * Data structure for category recommendation cards
 */
export interface ChatUIEnhancementCategoryCard {
  title: string;
  slug: string;
  id: string;
}

export type ChatUIEnhancementContentCardMediaType =
  (typeof ChatUIEnhancementContentCardMediaType)[keyof typeof ChatUIEnhancementContentCardMediaType];

export const ChatUIEnhancementContentCardMediaType = {
  video: 'video',
  audio: 'audio',
} as const;

/**
 * Data structure for content recommendation cards
 */
export interface ChatUIEnhancementContentCard {
  id: string;
  title: string;
  summary: string;
  slug: string;
  media_type: ChatUIEnhancementContentCardMediaType;
  category?: ChatUIEnhancementCategoryCard | null;
  thumbnail?: string | null;
  estimated_mins: number | null;
  asset_token?: string | null;
}

/**
 * Types of UI enhancements that can be rendered
 */
export type UIEnhancementType =
  (typeof UIEnhancementType)[keyof typeof UIEnhancementType];

export const UIEnhancementType = {
  content_card: 'content_card',
  category_card: 'category_card',
} as const;

/**
 * A UI enhancement message to be sent by the assistant
 */
export interface ChatUIEnhancementMessage {
  type?: 'ui_enhancement';
  subtype: UIEnhancementType | null;
  value: ChatUIEnhancementContentCard | ChatUIEnhancementCategoryCard | null;
}

export type ChatbotKey = (typeof ChatbotKey)[keyof typeof ChatbotKey];

export const ChatbotKey = {
  default: 'default',
  onboarding: 'onboarding',
  voice: 'voice',
  guided: 'guided',
} as const;

export interface ClientMetadata {
  clientSentAtUtcTimestamp?: string | null;
}

/**
 * Follow up command message to be sent by client
 */
export const FollowUpCommandMessageValue = {
  type: 'command',
  subtype: 'follow_up',
  type_discriminator: 'command:follow_up',
} as const;
export type FollowUpCommandMessage = typeof FollowUpCommandMessageValue;

/**
 * Onboarding command message to be sent by client to trigger onboarding flow
 */
export const OnboardingCommandMessageValue = {
  type: 'command',
  subtype: 'onboarding',
  type_discriminator: 'command:onboarding',
} as const;
export type OnboardingCommandMessage = typeof OnboardingCommandMessageValue;

/**
 * Push notification command message to prompt Nova to start a conversation
 */
export interface PushNotificationCommandMessage {
  type?: 'command';
  subtype?: 'push_notification';
  type_discriminator?: 'command:push_notification';
  additional_info?: string | null;
}

/**
 * URL prompt command message sent via email deep link with an HMAC-signed prompt
 */
export interface UrlPromptCommandMessage {
  type?: 'command';
  subtype?: 'url_prompt';
  type_discriminator?: 'command:url_prompt';
  /** @maxLength 8192 */
  encoded_prompt: string;
  /**
   * @minLength 43
   * @maxLength 44
   */
  encoded_signature: string;
}

/**
 * A conversation starter message to be sent by user
 */
export interface ConversationStarterMessage {
  type?: 'conversation_starter';
  subtype?: string | null;
  type_discriminator?: 'conversation_starter';
  value: string | null;
  starter_id: string;
}

/**
 * The data passed as part of a request to the /conversation endpoint
 */
export interface ConversationInput {
  message:
    | ChatTextMessageInput
    | FollowUpCommandMessage
    | OnboardingCommandMessage
    | PushNotificationCommandMessage
    | UrlPromptCommandMessage
    | AdviceCardMessage
    | ConversationStarterMessage;
  metadata: ClientMetadata;
}

export type ConversationManagerStarterTopic =
  (typeof ConversationManagerStarterTopic)[keyof typeof ConversationManagerStarterTopic];

export const ConversationManagerStarterTopic = {
  team_leadership: 'team_leadership',
  difficult_conversations: 'difficult_conversations',
  change_and_strategy: 'change_and_strategy',
} as const;

export interface MessageContent {
  body: string;
}

export type MappedMessageType =
  (typeof MappedMessageType)[keyof typeof MappedMessageType];

export const MappedMessageType = {
  text: 'text',
  voice: 'voice',
} as const;

export type MappedConversationRole =
  (typeof MappedConversationRole)[keyof typeof MappedConversationRole];

export const MappedConversationRole = {
  user: 'user',
  assistant: 'assistant',
} as const;

export interface MappedConversationMessage {
  id: string;
  created_at: string;
  content: MessageContent | (MessageContent | ChatUIEnhancementMessage)[];
  type: MappedMessageType;
  role: MappedConversationRole;
}

export interface ConversationMessagePagination {
  hasNext: boolean;
  hasPrevious: boolean;
  startCursor?: string | null;
  endCursor?: string | null;
  items: MappedConversationMessage[];
  conversation_id?: string | null;
}

export type ConversationStarterTopic =
  (typeof ConversationStarterTopic)[keyof typeof ConversationStarterTopic];

export const ConversationStarterTopic = {
  self_reflection: 'self_reflection',
  goal_setting: 'goal_setting',
  work_support: 'work_support',
  stress_and_coping: 'stress_and_coping',
  motivation: 'motivation',
  focus_and_productivity: 'focus_and_productivity',
  wellbeing_resources: 'wellbeing_resources',
} as const;

export const ConversationStarterTopicProperty = {
  ...ConversationStarterTopic,
  ...ConversationManagerStarterTopic,
} as const;
export interface ConversationStarter {
  id: string;
  text: string;
  emoji: string;
  topic: (typeof ConversationStarterTopicProperty)[keyof typeof ConversationStarterTopicProperty];
}

/**
 * Terminal frame on the /conversation stream when generation fails.

Starlette sends `http.response.start` before draining the body, so the
response is already committed to 200 by the time a mid-stream failure is
known — the failure has to travel in-band. Raising instead aborts the body
without its terminating chunk, which leaves the client waiting on a stream
that never ends (ENG-22040).

The code is deliberately fixed rather than carrying the underlying error,
so nothing internal is leaked to the client.
 */
export const ConversationStreamingErrorValue = {
  type: 'error',
  error: 'generation_failed',
} as const;
export type ConversationStreamingError = typeof ConversationStreamingErrorValue;

/**
 * A generated chunk on the /conversation stream.

`type` discriminates the frame; `content.type` discriminates what the frame
carries (text vs UI enhancement). They are deliberately different levels.
 */
export interface ConversationStreamingSuccess {
  type?: 'success';
  id: string;
  sequence_id: number;
  content: ChatTextMessageOutput | ChatUIEnhancementMessage;
  triggered_by_user_message_id: string;
}

export type ConversationStyle =
  (typeof ConversationStyle)[keyof typeof ConversationStyle];

export const ConversationStyle = {
  Active_Listening: 'Active Listening',
  Coaching: 'Coaching',
  Practical_Tools: 'Practical Tools',
} as const;

export type OnboardingStatus =
  (typeof OnboardingStatus)[keyof typeof OnboardingStatus];

export const OnboardingStatus = {
  notStarted: 'notStarted',
  inProgress: 'inProgress',
  skipped: 'skipped',
  completed: 'completed',
} as const;

export interface ConversationSummary {
  onboarding_status: OnboardingStatus;
  onboarding_completed_at?: string | null;
  last_message_at?: string | null;
}

export type Topic = (typeof Topic)[keyof typeof Topic];

export const Topic = {
  Help_Recommendations: 'Help Recommendations',
  Nova_Capabilities: 'Nova Capabilities',
  Privacy_and_Data_Security: 'Privacy and Data Security',
  'Therapy_&_Coaching_Information': 'Therapy & Coaching Information',
  Tracker_Recommendations: 'Tracker Recommendations',
  About_this_Platform: 'About this Platform',
} as const;

export interface ConversationVariableUpdateRequest {
  topics?: Topic[] | null;
  conversation_style?: ConversationStyle | null;
}

export interface ConversationVariables {
  topics?: Topic[];
  conversation_style?: ConversationStyle;
}

export interface ErrorResponse {
  detail: string;
}

export type ValidationErrorCtx = { [key: string]: unknown };

export interface ValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
  input?: unknown;
  ctx?: ValidationErrorCtx;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export interface PendingMessage {
  pending_message: boolean;
}

export type UncommittedMessageRole =
  (typeof UncommittedMessageRole)[keyof typeof UncommittedMessageRole];

export const UncommittedMessageRole = {
  user: 'user',
  assistant: 'assistant',
} as const;

export interface UncommittedMessage {
  id: string;
  content: string;
  role: UncommittedMessageRole;
  created_at?: string;
}

/**
 * The data passed as part of the request to the /voice/conversation endpoint
 */
export interface PersistVoiceMessagesInput {
  messages?: UncommittedMessage[];
}

/**
 * The response from the /voice/generate endpoint
 */
export interface SpeechResponse {
  id: string;
  user_message_id: string;
  type?: 'voice';
  value: string;
}

export interface VoiceSystemMessage {
  type?: 'voice_system_message';
  type_discriminator?: 'voice_system_message';
  value: string;
}

/**
 * The data passed as part of a request to the /voice/generate endpoint
 */
export interface VoiceConversationInput {
  message: ChatTextMessageInput | VoiceSystemMessage;
  uncommitted_messages?: UncommittedMessage[];
}

/**
 * The data passed as part of the request to the /voice/token endpoint
 */
export interface VoiceTokenInput {
  previous_call_errored?: boolean;
}

export type ConversationMessagesConversationMessagesGetParams = {
  /**
   * Maximum number of records to return
   */
  amount?: number;
  /**
   * Get records before this date
   */
  before?: string | null;
  /**
   * Whether the request is a multi-modal one
   */
  multi_modal?: boolean;
  chat_model_id?: ChatbotKey | null;
};

export type GenerateResponseConversationPostParams = {
  /**
   * Whether the request is a multi-modal one
   */
  multi_modal?: boolean;
  chat_model_id?: ChatbotKey | null;
  api_key?: string | null;
};

export type GenerateResponseVoiceGeneratePostParams = {
  chat_model_id?: ChatbotKey | null;
  api_key?: string | null;
};

export type PersistVoiceMessagesVoiceConversationPostParams = {
  chat_model_id?: ChatbotKey | null;
};
